// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2eYZ2","selects":"Documents_selects__1ccZ9"};